import './ReBetModal.scss';
import { ModalWrapper } from '../../platform/components/modal/ModalWrapper';
import { betStore, useTranslation, utilsStore } from '../../platform/stores';
import { observer } from 'mobx-react';
import { betService } from '../../platform/services';

export const ReBetModal = observer(() => {
  const t = useTranslation();
  const { doNotShowReBetModal, setDoNotShowReBetModal } = utilsStore;
  const { ticketToReBet, setTicketToReBet, historyItemToReBet, setHistoryItemToReBet } = betStore;

  const close = () => {
    setDoNotShowReBetModal(false);
    if (ticketToReBet != null) {
      setTicketToReBet(null);
    }

    if (historyItemToReBet != null) {
      setHistoryItemToReBet(null);
    }
  }

  const reBet = () => {
    if (ticketToReBet !== null) {
      betService.reBet(ticketToReBet);
      setTicketToReBet(null);
    }

    if (historyItemToReBet !== null) {
      betService.reBetRound(historyItemToReBet);
      setHistoryItemToReBet(null);
    }
  }

  return (
    <ModalWrapper hidden={ticketToReBet === null && historyItemToReBet === null} onClose={() => close()}>
      <div className="re-bet-modal-component">
        <div className="close-btn" onClick={() => close()}></div>
        <div className="title">{t('ARE_YOU_SURE_YOU_WANT_TO_REBET')}</div>
        <div className="do-not-show-again">
          <label className="checkbox">
            {t('DO_NOT_SHOW_AGAIN')}
            <input type="checkbox" value="" checked={doNotShowReBetModal} onChange={() => setDoNotShowReBetModal(!doNotShowReBetModal)}/>
            <span className="checkmark"></span>
          </label>
        </div>
        <div className="flex-between">
          <div className="flex-center cursor-pointer button" onClick={() => close()}>{t('REBET_NO')}</div>
          <div className="flex-center cursor-pointer button green" onClick={() => reBet()}>{t('REBET_YES')}</div>
        </div>
      </div>
    </ModalWrapper>
  );
});
